import { use, useEffect, useState } from 'react';
import ErrorMessageProviderContext from 'shared/components/error/providers/contexts/error-message-context';

import EmergencyAlarmSetting from '../domain/models/emergency-alarm-setting';
import useEmergencyAlarmSettingsDetails, { EmergencyAlarmSettingsDetailsHook } from '../hooks/emergency-alarm-settings-details-hook';
import { useReadEmergencyAlarmSettings } from './emergency-alarm-settings-queries';

export interface IEmergencyAlarmSettingsHook {
  organisationEmergencyAlarmSettings: EmergencyAlarmSetting[] | undefined;
  defaultTemplateSetting: EmergencyAlarmSetting | undefined;
  emergencyAlarmSettingsDetailsHook: EmergencyAlarmSettingsDetailsHook;
  emergencyAlarmSettingsIsLoading: boolean;
}

const useEmergencyAlarmSettings = (): IEmergencyAlarmSettingsHook => {
  const { setErrorMessage } = use(ErrorMessageProviderContext);
  const [organisationEmergencyAlarmSettings, setOrganisationEmergencyAlarmSettings] = useState<EmergencyAlarmSetting[]>();

  const [defaultTemplateSetting, setDefaultTemplateSetting] = useState<EmergencyAlarmSetting>();

  const emergencyAlarmSettingsDetailsHook = useEmergencyAlarmSettingsDetails();

  const {
    data: emergencyAlarmSettingsResponse,
    isLoading: emergencyAlarmSettingsIsLoading,
    isError: emergencyAlarmSettingsIsError,
    error: emergencyAlarmSettingsError,
  } = useReadEmergencyAlarmSettings();

  useEffect(() => {
    if (emergencyAlarmSettingsResponse?.emergencyAlarmSettings) {
      setOrganisationEmergencyAlarmSettings(emergencyAlarmSettingsResponse.emergencyAlarmSettings);
      setDefaultTemplateSetting(emergencyAlarmSettingsResponse.defaultTemplateSetting);
    }
  }, [emergencyAlarmSettingsResponse]);

  useEffect(() => {
    if (emergencyAlarmSettingsIsError) {
      setErrorMessage(emergencyAlarmSettingsError);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emergencyAlarmSettingsIsError]);

  return {
    defaultTemplateSetting,
    organisationEmergencyAlarmSettings,
    emergencyAlarmSettingsDetailsHook,
    emergencyAlarmSettingsIsLoading,
  };
};
export default useEmergencyAlarmSettings;
